import {Injectable} from "@angular/core";
import {
  BaseReleasedClassesStateModel,
  BaseReleasedClassesXsState
} from "../base/released-classes/base-released-classes-xs.state";
import {Action, Selector, State, StateContext, Store} from "@ngxs/store";
import {CompoApp} from "../../services/CompoApp";
import {CompoClass} from "../../models/component_class/CompoClass";
import {Observable} from "rxjs/internal/Observable";
import {ClassTreeNode} from "../../models/frontend_entities/ClassTreeNode";
import {throwError} from "rxjs";
import {FilesDetailReleasedClassesAction} from "./files-detail-released-classes.action";
import {DocumentGroupModel} from "../../models/document/document-group.model";
import {FilesDetailAction} from "../files-detail/files-detail.action";

interface FilesDetailReleasedClassesStateModel extends BaseReleasedClassesStateModel {
  selectedVersion: DocumentGroupModel;
}

const getDefaults = (initSelection?: Set<string>, currentSelection?: Set<string>):FilesDetailReleasedClassesStateModel  => ({
  ...BaseReleasedClassesXsState.getDefaults(initSelection, currentSelection),
  selectedVersion: null
});

@State<FilesDetailReleasedClassesStateModel>({
  name: 'filesDetailReleasedClasses',
  defaults: getDefaults()
})
@Injectable()
export class FilesDetailReleasedClassesXsState extends BaseReleasedClassesXsState{

  constructor(private app: CompoApp,
              private store: Store) {
    super();
  }

  protected getCompoClassTree(): Promise<CompoClass[]>{
    return this.app.classService.getClassTreeForOrg(this.app.data.getUser().organization.id);
  }
  protected performSave(state: FilesDetailReleasedClassesStateModel): Observable<any> {
    const selection = [...state.currentSelection];
    const documentGroupId = state.selectedVersion?.id;

    return this.app.documentGroupService.saveReleasedClassSelection(documentGroupId, selection);
  }

  protected postSave(state: FilesDetailReleasedClassesStateModel, resp?: any): void {
    const documentGroupId = state.selectedVersion?.id;
    this.store.dispatch(new FilesDetailAction.Fetch(documentGroupId));
  }

  @Selector()
  static classTree(state: FilesDetailReleasedClassesStateModel): ClassTreeNode[] | null {
    return super.classTree(state);
  }

  @Selector()
  static requestInProgress(state: FilesDetailReleasedClassesStateModel): boolean{
    return super.requestInProgress(state);
  }

  @Selector()
  static selection(state: FilesDetailReleasedClassesStateModel): Set<string> | null {
    return super.selection(state);
  }

  @Selector()
  static selectionOnlyLeafs(state: FilesDetailReleasedClassesStateModel): Set<string> | null {
    return super.selectionOnlyLeafs(state);
  }

  @Selector()
  static allClassIds(state: FilesDetailReleasedClassesStateModel): string[] {
    return super.allClassIds(state);
  }

  @Selector()
  static classReleaseInProgress(state: FilesDetailReleasedClassesStateModel): boolean {
    return super.classReleaseInProgress(state);
  }

  @Selector()
  static saveRequired(state: FilesDetailReleasedClassesStateModel): boolean {
    return super.saveRequired(state);
  }

  @Action(FilesDetailReleasedClassesAction.Initialize)
  public initialize(ctx: StateContext<FilesDetailReleasedClassesStateModel>,
                    action: FilesDetailReleasedClassesAction.Initialize): Observable<void>  {
    if (!action.version) {
      return throwError(() => new Error('No document group version is present!'));
    }

    const initialSelection =  new Set<string>(action.version.releasedClasses);
    const currentSelection = new Set<string>(action.version.releasedClasses);

    ctx.patchState({
      ...getDefaults(initialSelection, currentSelection),
      selectedVersion: action.version,
      inProgress: true
    });

    // @ts-ignore
    return this.initSelection(ctx);
  }

  @Action(FilesDetailReleasedClassesAction.ChangeSelection)
  public change(ctx: StateContext<FilesDetailReleasedClassesStateModel>,
                action: FilesDetailReleasedClassesAction.ChangeSelection): void  {
    if (!action.ids) {
      throwError(() => new Error('No ids provided to for the selection!'));
      return;
    }
    // @ts-ignore
    return this.changeSelection(ctx,action.ids);
  }

  @Action(FilesDetailReleasedClassesAction.Save)
  public save(ctx: StateContext<FilesDetailReleasedClassesStateModel>,
              action: FilesDetailReleasedClassesAction.Save): Observable<void>  {
    const state = ctx.getState();
    if (!state.selectedVersion) {
      return throwError(() => new Error('No version provided'));
    }

    // @ts-ignore
    return this.saveSelection(ctx);
  }

  @Action(FilesDetailReleasedClassesAction.ResetToInitialSelection)
  public reset(ctx: StateContext<FilesDetailReleasedClassesStateModel>,
               action: FilesDetailReleasedClassesAction.ResetToInitialSelection): void {
    // @ts-ignore
    return this.resetSelection(ctx);
  }

}
